import { defaultPermissions } from "routes/enum";

export const hasPermissionCodes = (permissionCodes = [], requiredCodes = []) => {
    if (!requiredCodes?.length) {
        return true;
    }

    const grantedCodes = new Set(permissionCodes);

    return [...requiredCodes, ...defaultPermissions].some((code) =>
        grantedCodes.has(code)
    );
};

export const pickValidRoute = (tabbedRoutes, permissionCodes) => {
    for (let i = 0; i < tabbedRoutes?.length; i++) {
        const route = tabbedRoutes[i];
        if (hasPermissionCodes(permissionCodes, route?.baseResources)) {
            return route?.path;
        }
    }

    return undefined;
};

export const checkDropdownForPermission = (title) => {
    return title === "Setting";
};
